'use client';

import type { ChatStatus } from 'ai';
import { useState } from 'react';
import {
  PromptInput,
  PromptInputAttachment,
  PromptInputAttachments,
  PromptInputBody,
  PromptInputSubmit,
  PromptInputTextarea,
  PromptInputToolbar,
  PromptInputTools,
  type PromptInputMessage,
} from './elements/prompt-input';

interface ChatInputProps {
  onSubmit: (message: PromptInputMessage) => void;
  status: ChatStatus;
}

const MAX_CHARS = 3000;

export function ChatInput({ onSubmit, status }: ChatInputProps) {
  const [input, setInput] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= MAX_CHARS) {
      setInput(value);
    }
  };

  const handleSubmit = (message: PromptInputMessage) => {
    onSubmit(message);
    setInput('');
  };

  return (
    <PromptInput onSubmit={handleSubmit} className="shrink-0" globalDrop multiple>
      <PromptInputBody>
        <PromptInputAttachments>
          {(attachment) => <PromptInputAttachment data={attachment} />}
        </PromptInputAttachments>
        <PromptInputTextarea onChange={handleInputChange} value={input} maxLength={MAX_CHARS} />
      </PromptInputBody>
      <PromptInputToolbar>
        <PromptInputTools>
          <div className="text-sm text-muted-foreground ml-3">
            {input.length}/{MAX_CHARS}
          </div>
        </PromptInputTools>
        <PromptInputSubmit disabled={!input} status={status} />
      </PromptInputToolbar>
    </PromptInput>
  );
}
